// extracted by mini-css-extract-plugin
export default {"infoList":"basicInformation_infoList__IEcEi","infoItem":"basicInformation_infoItem__RtzEO"};